import React, { useEffect,useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { BsThreeDotsVertical } from "react-icons/bs";

const VedioCard = ({vedio}) => {


  const [tempData , setTempData] = useState(null);
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [SuscribeText, setSuscribeButtonText] = useState('Suscribe');
  const navigate = useNavigate();

  const toggleDropdown = () => {
    setDropdownVisible(!isDropdownVisible);
  };

  useEffect(()=>{
    let data = JSON.parse(localStorage.getItem("userDetails"))
    setTempData(data);


    let index =  data['subscription'].findIndex(element => vedio.channel_id === element.id);
   if(index)
   {
    setSuscribeButtonText('Unsuscribe');
   }

    // setWatchHistory(data.watchHistory.length===0 ? null : data.watchHistory);
    



  },[])

  const addToSuscribe = (vidData)=>{

    if(SuscribeText === 'Unsuscribe')
        {
          removeFromSuscribe(vidData);
          return ;
        }
   console.log(vidData);
   

      let tempData = {
        id:vidData.channel_id,        
        img:vidData.thumbnails[0].url,         
        channelName: vidData.author
      }

      let data = JSON.parse(localStorage.getItem("userDetails"));
      data['subscription'].push(tempData);
      setSuscribeButtonText('Unsuscribe');
      
      localStorage.setItem("userDetails", JSON.stringify(data));
    
  }
    
  const removeFromSuscribe = (vidData)=>{

    let data = JSON.parse(localStorage.getItem("userDetails"));
   
    let index =  data['subscription'].findIndex(element => vidData.channel_id === element.id);

    // let index = data['subscription'].indexOf(channelDetails.id); // Find the index of the element


    data['subscription'].splice(index, 1); 
    setSuscribeButtonText('Suscribe');
    localStorage.setItem("userDetails", JSON.stringify(data));
  }
  const addToHistory=(vidDetails)=>{



      let data = JSON.parse(localStorage.getItem("userDetails"))
      

      let present = false;
      data?.watchHistory?.forEach(vedio => {
          if(vedio.title === vidDetails.title)
            {
              present = true;
            }
      });
      
      if(!present)
        {
          data.watchHistory.push(vidDetails);
        }

      data.currDate = new Date();

      
      localStorage.setItem("userDetails", JSON.stringify(data));

  }

  function ShortNumber(number) {

    if (number >= 1000000) {
      return (number / 1000000).toFixed(1) + "M";
    } else if (number >= 1000) {
      return (number / 1000).toFixed(1) + "k";
    } else {
      return number.toString();
    }
  }

  function addTo(query, vidDetails)
  {

    let data = JSON.parse(localStorage.getItem("userDetails"))
    
    if(query === 'w')
      {
          data.watchLater.push(vidDetails);
      }
    else if(query === 'f')
      {
          data.favorite.push(vidDetails);
      }
      else if(query === 'p')
        {
          data.watchLater.push(vidDetails);
        }
        else {
          // settings
        }

        data.currDate = new Date()
        localStorage.setItem("userDetails", JSON.stringify(data));
        setTempData(data);

        
        toggleDropdown();

    return '';
  }

  function removeTo(query, vidDetails)
  {
    let data = JSON.parse(localStorage.getItem("userDetails"))
    
    
    
    if(query === 'w')
      {
        
        let idx = data.watchLater.findIndex((vid)=>vid.title === vidDetails.title);
        data.watchLater.splice(idx,1);
        // data.watchLater = data.watchLater.filter((vid)=> vid !== vidDetails)
        
          
      }
    else if(query === 'f')
      {
        let idx = data.favorite.findIndex((vid)=>vid.title === vidDetails.title);
        data.favorite.splice(idx,1);
        // data.watchLater = data.favorite.filter((vid)=> vid !== vidDetails)
          
      }
      else if(query === 'p')
        {
          let idx = data.watchLater.findIndex((vid)=>vid.title === vidDetails.title);
          data.watchLater.splice(idx,1);
          // data.watchLater = data.watchLater.filter((vid)=> vid !== vidDetails)
          
        }
        else {
          // settings
        }

        data.currDate = new Date()
        localStorage.setItem("userDetails", JSON.stringify(data));
        setTempData(data);
        
        toggleDropdown();
        return "";

  }

  function findVedio(vedio,query){
    if(query === "w")
      return tempData?.watchLater.findIndex((ele)=> ele.title === vedio.title) === -1;
    
    if(query === "f")
      return tempData?.favorite.findIndex((ele)=> ele.title === vedio.title) === -1;

    if(query === "p")
      return tempData?.watchLater.findIndex((ele)=> ele.title === vedio.title) === -1;

  }

  
    
  return (
            // <Link  to={`/play/:${vedio.video_id}`}>

            
            <button onClick={()=>addToHistory(vedio)}  className="group  bg-black h-80 rounded-lg hover:text-gray-300 hover:border border-gray-500 shadow-sm hover:shadow-none shadow-gray-800">
              <Link to={`/play/:${vedio.video_id}`} className="relative block bg-black sm:opacity-75 hover:opacity-100 overflow-hidden rounded-lg group lg:aspect-none">
                  <div className="relative overflow-hidden">
                      <img
                          src={vedio?.thumbnails[1]?.url ?? vedio?.thumbnails[0]?.url}
                          alt={''}
                          className="max-h-48 w-full object-cover object-center transition-transform duration-500 ease-in-out group-hover:scale-95  group-hover:opacity-90 lg:h-full lg:w-full"
                      />
                      <div className="badge absolute bottom-0 right-0 m-2 text-end">
                          <p className="text-sm font-bold inline bg-black text-white z-20 px-1 rounded-md">{vedio.video_length}</p>
                      </div>
                  </div>
              </Link>

              
                          
            <div className="details flex  justify-between p-1">

                <Link to={`/channel/${vedio.channel_id}`} className="logo h-24 w-12  mr-3 ">
                <img className="rounded-full h-12 w-12" src={vedio?.thumbnails[1]?.url ?? vedio?.thumbnails[0]?.url} alt="" srcSet="" />
                </Link>


                <div className="innerDetails flex flex-col text-left  space-y-2 ">

                  {/* desktop */}
                <h1 className=" hidden sm:block text-xl font-serif font-normal ml-2" >{vedio.title.length > 50 ? vedio.title.slice(0,50)+"..." :vedio.title}</h1>

                {/* mobile */}
                <h1 className="block sm:hidden text-xl font-serif  font-normal ml-2" >{vedio.title.length > 45 ? vedio.title.slice(0,45)+"..." :vedio.title}</h1>
                
                <span className="font-sm font-light hidden sm:block ml-2 text-gray-400">{vedio.author}</span>

                
                <div className="flex justify-between px-2">
                  <div className='flex space-x-2'>
                    <p className="font-sm text-gray-500">{ShortNumber(vedio.number_of_views)} views</p>
                    <p className="font-sm text-gray-500">{vedio.published_time}</p>
                  </div>


              


<div className="relative">
      <div className="dropdown-container">
        <BsThreeDotsVertical
          className="text-2xl text-gray-500 hover:text-white cursor-pointer dropdown-trigger"
          onClick={toggleDropdown}
        />
        {isDropdownVisible && (
          <div className="dropdown-menu absolute bottom-full right-0 mb-2 divide-y divide-gray-100 rounded-lg shadow w-48 bg-gray-700 z-50">
            <ul className="py-2 text-sm text-gray-200">
              <li>
                {findVedio(vedio, "w") ? (
                  <button
                    onClick={() => addTo("w", vedio)}
                    className="w-full text-start px-4 py-2  hover:bg-gray-600 "
                  >
                    Add to Watch Later
                  </button>
                ) : (
                  <button
                    onClick={() =>removeTo("w", vedio)}
                    className="w-full text-start px-4 py-2  hover:bg-gray-600"
                  >
                    Remove from Watch Later
                  </button>
                )}
              </li>
             
              <li>
                {findVedio(vedio, "f") ? (
                  <button
                    onClick={() => addTo("f", vedio)}
                    className="w-full text-start px-4 py-2 hover:bg-gray-600 dark:hover:text-white"
                  >
                    Add to Favorite
                  </button>
                ) : (
                  <button
                    onClick={() => removeTo("f", vedio)}
                    className="w-full text-start px-4 py-2 hover:bg-gray-600 dark:hover:text-white"
                  >
                    Remove from Favorite
                  </button>
                )}
              </li>
              {/* <li>
               
                  <button
                    onClick={() => addToSuscribe(vedio)}
                    className="w-full text-start px-4 py-2 hover:bg-gray-600 dark:hover:text-white"
                  >
                    {SuscribeText}
                  </button>
                
                  
                  
              </li> */}
              <li>
                <button
                  onClick={() => navigate('/settings')}
                  className="w-full text-start px-4 py-2 hover:bg-gray-600 dark:hover:text-white"
                >
                  Settings
                </button>
              </li>
            </ul>
          </div>
        )}
      </div>
    </div>
                  
                </div>
                </div>
                
            </div>
        </button>

        // </Link>
  )
}

export default VedioCard


// const VedioCard = ({vedio}) => {

//     function calculateDuration(oldDate) {
//         const timeDifference = Date.now() - new Date(oldDate);
    
//         const units = [
//           { interval: 1000 * 60 * 60 * 24 * 365, label: "year" },
//           { interval: 1000 * 60 * 60 * 24 * 30, label: "month" },
//           { interval: 1000 * 60 * 60 * 24 * 7, label: "week" },
//           { interval: 1000 * 60 * 60 * 24, label: "day" },
//           { interval: 1000 * 60 * 60, label: "hour" },
//           { interval: 1000 * 60, label: "minute" },
//         ];
    
//         for (const unit of units) {
//           const interval = Math.floor(timeDifference / unit.interval);
//           if (interval >= 1) {
//             return `${interval} ${unit.label}${interval === 1 ? "" : "s"}`;
//           }
//         }
    
//         return "Less than a minute";
//       }
//     const { id : {videoId} , snippet : {thumbnails : {high}, title, channelTitle, publishTime}} = vedio;


//   return (
//             <Link to={`/play/:${videoId}`}>
            
//             <div key={videoId} className="group  bg-black h-72 rounded-lg  ">
//             <div className=" bg-black overflow-hidden rounded-lg bg-graye-200 lg:aspect-none group-hover:opacity-75 ">
//             <img
//                 src={high.url}
//                 alt={title}
//                 className="max-h-36 w-full object-cover object-center lg:h-full lg:w-full"
//             />
//             </div>
            
//             <div className="details flex  justify-between p-1">

//                 <div className="logo h-8 w-10 mr-3 ">
//                 <img className="rounded-full" src="https://tailwindui.com/img/ecommerce-images/product-page-01-related-product-01.jpg" alt="" srcSet="" />
//                 </div>


//                 <div className="innerDetails flex flex-col justify-center space-y-2 ">
//                 <h1 className="text-xl font-serif font-normal" >{title.length > 40 ? title.slice(0,40)+"..." :title}</h1>
                
//                 <span className="font-sm font-light text-gray-400">{channelTitle}</span>

                
//                 <div className="flex">
//                     {/* <p className="font-sm text-gray-500">views</p> */}
//                     <p className="font-sm text-gray-500">{calculateDuration(publishTime)} ago</p>
//                 </div>
//                 </div>
                
//             </div>
//         </div>

//         </Link>
//   )
// }

// export default VedioCard
